
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["i-Layer_1",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","stroke":"currentColor","fill":"transparent","class":"i-Layer_1"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.96 23.06V9.48l10.56-7.54 10.57 7.54v13.58H1.96z"}})])
          )
        }
      }
    